import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import './App.css';

const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const Tickets = React.lazy(() => import('./pages/Tickets'));
const TicketDetail = React.lazy(() => import('./pages/TicketDetail'));
const Machines = React.lazy(() => import('./pages/Machines'));
const Technicians = React.lazy(() => import('./pages/Technicians'));
const Parts = React.lazy(() => import('./pages/Parts'));
const Dispatches = React.lazy(() => import('./pages/Dispatches'));
const Analytics = React.lazy(() => import('./pages/Analytics'));
const Integrations = React.lazy(() => import('./pages/Integrations'));
const AuditLog = React.lazy(() => import('./pages/AuditLog'));

const PageLoader = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
  </div>
);

function AppRouter() {
  const location = useLocation();
  // Support providers that return session_id in hash or query.
  if (location.hash?.includes('session_id=') || location.search?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="tickets/:id" element={<TicketDetail />} />
        <Route path="machines" element={<Machines />} />
        <Route path="technicians" element={<Technicians />} />
        <Route path="parts" element={<Parts />} />
        <Route path="dispatches" element={<Dispatches />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="analytics" element={<Analytics />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<PageLoader />}>
          <AppRouter />
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
